import * as React from 'react';
import { formatInteger } from 'helpers/common';

require('./style.css');

interface IProps {
	isLiked: boolean;
	likeItem: (isAuthenticated: () => boolean, signinRedirect: () => void) => void;
	unlikeItem: (isAuthenticated: () => boolean, signinRedirect: () => void) => void;
	isAuthenticated: any;
	signinRedirect: any;
	likesCount?: number;
}

const LikeButton = (props: IProps) => {
	const { likeItem, unlikeItem, isLiked, isAuthenticated, signinRedirect, likesCount } = props;

	const likeItemClick = (e: React.SyntheticEvent, isAuthenticated: () => boolean, signinRedirect: () => void) => {
		e.preventDefault();
		if (likeItem && !isLiked) {
			likeItem(isAuthenticated, signinRedirect);
		} else if (unlikeItem && isLiked) {
			unlikeItem(isAuthenticated, signinRedirect);
		}
	};

	if (!likeItem && !unlikeItem) {
		return null;
	}

	let likeBtnContent: JSX.Element = null;
	if ((isLiked === undefined || isLiked === null) && isAuthenticated()) {
		likeBtnContent = (
			<div className="likeButton disabled">
				{likesCount !== undefined ? <div className="likesCount">{formatInteger(likesCount || 0)}</div> : null}
				<div className="likeImg">
					<img src={require('containers/Html/icons/glossiq/likebuttonplus.svg')} />
				</div>
			</div>
		);
	} else if (!isLiked) {
		likeBtnContent = (
			<div className="likeButton">
				{likesCount !== undefined ? <div className="likesCount">{formatInteger(likesCount)}</div> : null}
				<div className="likeImg" onClick={(e) => likeItemClick(e, isAuthenticated, signinRedirect)}>
					<img src={require('containers/Html/icons/glossiq/likebuttonplus.svg')} />
				</div>
			</div>
		);
	} else {
		likeBtnContent = (
			<div className="likeButton likeButtonLiked">
				{likesCount !== undefined ? <div className="likesCount">{formatInteger(likesCount)}</div> : null}
				<div className="likeImg" onClick={(e) => likeItemClick(e, isAuthenticated, signinRedirect)}>
					<img src={require('containers/Html/icons/glossiq/likebuttonplusgreen.svg')} />
				</div>
			</div>
		);
	}

	return likeBtnContent;
};

export { LikeButton };
